module.exports = __webpack_public_path__ + "static/media/marker-vessel-berhenti.4a160dcb.svg";